// frontend/src/utils/storage.js

/**
 * Returns a usable localStorage reference or null when not available (SSR,
 * Safari private mode, etc.).
 */
export const getSafeLocalStorage = () => {
  if (typeof window === "undefined") return null;
  try {
    const storage = window.localStorage;
    const testKey = "__storage_test__";
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return storage;
  } catch (err) {
    console.warn("[storage] localStorage unavailable:", err.message);
    return null;
  }
};

export const safeGetItem = (key) => {
  const storage = getSafeLocalStorage();
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch (err) {
    console.warn("[storage] getItem failed", key, err.message);
    return null;
  }
};

export const safeSetItem = (key, value) => {
  const storage = getSafeLocalStorage();
  if (!storage) return false;
  try {
    storage.setItem(key, value);
    return true;
  } catch (err) {
    console.warn("[storage] setItem failed", key, err.message);
    return false;
  }
};

export const safeRemoveItem = (key) => {
  const storage = getSafeLocalStorage();
  if (!storage) return false;
  try {
    storage.removeItem(key);
    return true;
  } catch (err) {
    console.warn("[storage] removeItem failed", key, err.message);
    return false;
  }
};

export const safeGetJSON = (key, fallback = null) => {
  const raw = safeGetItem(key);
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch (err) {
    console.warn("[storage] JSON parse failed", key, err.message);
    return fallback;
  }
};
